import { userAuthTypes } from "./auth.types"

export interface IAuthData {
    accountId: string | null,
    token: string | null,
    userId: string | null
}


export interface IStateAuthReducer {
    authData?: IAuthData | null,
    isLoading: boolean | null
}

const INITIAL_STATE : IStateAuthReducer = {
    authData: null,
    isLoading: false
    
}

/* ============= REDUCER ============== */
export const authReducer = (state = INITIAL_STATE, action: any) :  IStateAuthReducer => {
    switch (action.type) {
        case  userAuthTypes.IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
        case userAuthTypes.SET_AUTH_DATA:
            return {
                ...state,
                authData: action.payload
            }
        default:
            return state
    }
}

export default authReducer

